<template>
	<section class="web">
		<Nav :title="title" />
		<iframe :src="src" ref="iframe" class="view" :style="{height: height+'px'}"></iframe>
	</section>
</template>

<script>
import Nav from "components/Nav"

export default {
	components: {
		Nav,
	},
	data() {
        return {
			src: '',
			title: '',
			height: '',
		}
    },
	created() {
		this.height = document.documentElement.clientHeight-46
		this.src = this.$route.params.src
		this.title = this.$route.params.t
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
	},
}
</script>


<style lang="scss">
	.web {
		padding-top: 46px;
		color: #2B2F3A;
		.view {
			position: fixed;
			top: 46px;
			left: 0;
			width: 100%;
			height: auto;
			border: 0;
		}
	}

</style>


// WEBPACK FOOTER //
// src/views/webview/Webview.vue